import api from '../api';

class LeadsApi {

    constructor() {
        this.endpoint = 'leads';
    }

    create = data => {
        return api.post(`${this.endpoint}/create`, data);
    }

    getByConfirmationCode= (code) => {
        return api.get(this.endpoint + '?by=default-search&confirmation=' + code, {});
    }

    confirm = code => {
        return api.post(`${this.endpoint}/confirm?confirmation=${code}`, {});
    }
   

}

const instance = new LeadsApi();

export default instance;